import type { Stripe } from '@stripe/stripe-js';

import type { StripeCardElementsGroup } from '../components/stripe-card-fields/types';

export interface CreatePaymentMethodFromGroupParams {
  stripe: Stripe;
  group: StripeCardElementsGroup;
  nameOnCard: string;
  billing?: {
    line1: string;
    city: string;
    postal_code: string;
    country: string;
  };
}

export function createPaymentMethodFromGroup({
  stripe,
  group,
  nameOnCard,
  billing,
}: CreatePaymentMethodFromGroupParams): ReturnType<Stripe['createPaymentMethod']> {
  return stripe.createPaymentMethod({
    type: 'card',
    card: group.cardNumber,
    billing_details: billing
      ? {
          name: nameOnCard,
          address: billing,
        }
      : {
          name: nameOnCard,
        },
  });
}
